import { render, staticRenderFns } from "./r-item-group-page.vue?vue&type=template&id=1038ee8d&scoped=true&class=item-group-page"
import script from "./r-item-group-page.vue?vue&type=script&lang=js"
export * from "./r-item-group-page.vue?vue&type=script&lang=js"
import style0 from "./r-item-group-page.vue?vue&type=style&index=0&id=1038ee8d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038ee8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1038ee8d')) {
      api.createRecord('1038ee8d', component.options)
    } else {
      api.reload('1038ee8d', component.options)
    }
    module.hot.accept("./r-item-group-page.vue?vue&type=template&id=1038ee8d&scoped=true&class=item-group-page", function () {
      api.rerender('1038ee8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-group/r-item-group-page.vue"
export default component.exports